import modal from './modal';

modal();
